// Imports
import $ from 'jquery';
import createHistory from 'history/createBrowserHistory';
import attachEnterAsClick from 'utils/attachEnterAsClick';
import { getParameterByName, getNonRelatedQueryStrings } from 'utils/query-param-helpers';

// The functions to call
initTabs();

// Functions
function initTabs() {
    const tabGroupClass = '.js-tabs';
    const tabItemClass = '.js-tab-item';

    // early return if no component found
    if (!$(tabItemClass).length) { return; }

    // Handle tab item click
    $(tabItemClass).click(function () {
        // Remove all active class from siblings
        $(this).closest(tabGroupClass).find(tabItemClass).removeClass('active');
        $(this).closest(tabGroupClass).find(tabItemClass).attr('tabindex', '0');

        // Add active class it itself
        $(this).addClass('active');
        $(this).attr('tabindex', '');

        // Find the tab content selector and show / hide the content
        const tabContentId = $(this).closest(tabGroupClass).data('tab-content-id');
        if (tabContentId) {
            // Hide all immidiate children of the tab content
            $(`#${tabContentId} > *`).hide();

            // Show the children of the tab content with the same index as the active tab item
            $(`#${tabContentId} > *:nth-child(${($(this).index() + 1)})`).show();
            // Update the query string to allow the tab to open when the same url is used
            updateQueryString(tabContentId, $(this).attr('id'));
        }

        // Trigger a windows resize call to cause some plugins like float table header to kick off
        $(window).resize();
    });
    attachEnterAsClick($(tabItemClass));

    // Set the active tabs based on query string
    initActiveTabFromQueryString(tabGroupClass);

    // On init, programatically click the active tab, if no active tab present click the first tab
    if ($(`${tabItemClass}.active`).length) {
        $(`${tabItemClass}.active`).click();
    } else {
        $(`${tabItemClass}:first-child`).click();
    }
}

function updateQueryString(tabContentId, activeIndex) {
    // Preserve all the non-this tab related query strings and then add on to the query string for the active tab
    const urlSub = window.location.search.substring(1);
    const activeQuery = getActiveTabQueryString(tabContentId);
    const preserveQueryStrings = getNonRelatedQueryStrings(urlSub, activeQuery);
    preserveQueryStrings.push(`${getActiveTabQueryString(tabContentId)}=${activeIndex}`);

    // Create the query params and save it to history
    const queryParams = `?${preserveQueryStrings.join('&')}`;
    const history = createHistory();
    history.replace({
        pathname: window.location.pathname,
        search: queryParams
    });
}

function initActiveTabFromQueryString(tabGroupClass) {
    // Check each of the tab group on the page for any matching active tab query string
    $(tabGroupClass).each(function () {
        const tabContentId = $(this).data('tab-content-id');

        // Only deal with tabs that's got active tab set
        if (!tabContentId) { return; }

        // Get the active index for the tab out of the query string
        const activeIndex = getParameterByName(getActiveTabQueryString(tabContentId));
        // Only active the tab if tab to active can be found
        const tabToActivate = $(this).find(`#${activeIndex}`);
        if (tabToActivate.length) {
            tabToActivate.click();
        }
    });
}

function getActiveTabQueryString(tabContentId) {
    return `tab-${tabContentId}`;
}
